




































import { Component, Prop, Vue } from "vue-property-decorator";


@Component
export default class ComingSoonModal extends Vue {
  @Prop({ required: true }) collectionName!: string;
}
